import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilitiesService {
  /////////////////
  constructor() { }

  //
  sortBy=field=> (a, b)=> a[field].localeCompare(b[field]);

  //Dates
  convertToDDMMYYYY=(date:string)=>{
    return date.split("-")[2] + "/" + date.split("-")[1] + "/" + date.split("-")[0];
  }

  removeDiacriticsAndSpaces=(value:string, toUpper:boolean)=>{
    if(value != null && value.length > 0){
      value = value.replace(/\s\s+/g, ' ');
      value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      if(toUpper) value = value.toUpperCase();
      return value.trim();
    }else{
      return "";
    }
  }

  containsOnlySomeNumbers(array1:number[], array2:number[]){
    console.log(">> containsOnlySomeNumbers");
    return array2.every(elem => array1.includes(elem))
  }

  getLasDay(year:number, month:number){
    return  new Date(year, month, 0).getDate();
  }
}
